import React from 'react';
import { Dialog, DialogContent, IconButton } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import { useCampfireTheme } from '../../../../theme/useCampfireTheme';
import { RosterTemplateForm } from '../roster-templates-screen/RosterTemplateForm';

interface AddRosterDialogProps {
  onClose: () => void;
  onSuccess?: () => void;
}

export const AddRosterDialog: React.FC<AddRosterDialogProps> = ({ onClose, onSuccess }) => {
  const { isMobile } = useCampfireTheme();

  const handleSuccess = () => {
    if (onSuccess) {
      onSuccess();
    }
    onClose();
  };

  return (
    <Dialog
      open
      onClose={onClose}
      maxWidth='lg'
      fullWidth
      fullScreen={isMobile}
      PaperProps={{
        style: {
          minHeight: isMobile ? '100vh' : '80vh',
          height: isMobile ? '100vh' : 'auto',
        },
      }}
    >
      {/* Close button */}
      <IconButton
        onClick={onClose}
        style={{
          position: 'absolute',
          right: 8,
          top: 8,
          zIndex: 1,
          backgroundColor: 'white',
        }}
        size='small'
      >
        <CloseIcon />
      </IconButton>

      {/* Dialog Content with RosterTemplateForm */}
      <DialogContent style={{ padding: 0, overflow: 'auto' }}>
        <RosterTemplateForm onSuccess={handleSuccess} />
      </DialogContent>
    </Dialog>
  );
};
